import styled from 'styled-components';
import { CustomErrorStyled } from '../../CustomErrorStyled';

export const CustomErrorStyledOV = styled(CustomErrorStyled)``;
